import { initializeApp } from "firebase/app";
import { getMessaging, getToken, Messaging, onMessage } from "firebase/messaging";
import { get } from "lodash";
import { PruToast } from "./components/pru-toast";

let firebaseConfig: any = {
  apiKey: get(window, "envConfig.REACT_APP_PUBLIC_FIREBASE_API_KEY", ""),
  authDomain: get(window, "envConfig.REACT_APP_PUBLIC_FIREBASE_AUTH_DOMAIN", ""),
  projectId: get(window, "envConfig.REACT_APP_PUBLIC_FIREBASE_PROJECT_ID", ""),
  storageBucket: get(window, "envConfig.REACT_APP_PUBLIC_FIREBASE_STORAGE_BUCKET", ""),
  messagingSenderId: get(window, "envConfig.REACT_APP_PUBLIC_FIREBASE_MESSAGING_SENDER_ID", ""),
  appId: get(window, "envConfig.REACT_APP_PUBLIC_FIREBASE_APP_ID", ""),
  measurementId: get(window, "envConfig.REACT_APP_PUBLIC_FIREBASE_MEASUREMENT_ID", ""),
  vapidKey: get(window, "envConfig.REACT_APP_PUBLIC_FIREBASE_VAPID_KEY", ""),
};
const requiredKeys = [
  "apiKey",
  "authDomain",
  "projectId",
  "storageBucket",
  "messagingSenderId",
  "appId",
  "measurementId",
  "vapidKey",
];
const missingKeys = requiredKeys.filter((key) => !firebaseConfig[key]);
if (missingKeys.length > 0) {
  // use coesit config as default
  firebaseConfig = {
    apiKey: "AIzaSyCtkjtmcHHjaeqF64BklE8wuJrvqshpi34",
    authDomain: "coe-pruforce-sit.firebaseapp.com",
    projectId: "coe-pruforce-sit",
    storageBucket: "coe-pruforce-sit.firebasestorage.app",
    messagingSenderId: "629758163605",
    appId: "1:629758163605:web:40171f4ae92c8ee5f6f99c",
    measurementId: "G-G7EQBYGERT",
    vapidKey:
      "BJXkp8_8ZJ3wtkiF1WSVQoRUcoDEDwmx04TtHSTadMeRr2k9HX3GlYBg81A8k6npCQ8umbkAPmc8h3FhzK0IgG8",
  };
}

const isBrowserSupported = () => {
  try {
    return (
      typeof window !== "undefined" &&
      "serviceWorker" in navigator &&
      "PushManager" in window &&
      "Notification" in window &&
      Notification.permission !== undefined
    );
  } catch (e) {
    console.warn("Browser support check failed:", e);
    return false;
  }
};
let app: any;
let messaging: Messaging = null as any;
try {
  if (isBrowserSupported()) {
    app = initializeApp(firebaseConfig);
    messaging = getMessaging(app);
  }
} catch (error) {
  console.error("Firebase initialization failed:", error);
}
let isListenerRegistered = false;
const setupForegroundMessageListener = () => {
  if (!messaging) {
    console.warn("Messaging not available, skipping foreground listener");
    return;
  }
  if (isListenerRegistered) {
    console.log("Foreground message listener already registered.");
    return;
  }
  onMessage(messaging, (payload) => {
    console.log("Received foreground message:", payload);

    const extendData = payload.data?.extendData;
    if (extendData) {
      try {
        // const parsedExtendData = JSON.parse(extendData);
        // onHandleNotification({
        //   item: { extendValue: parsedExtendData } as InboxMessage,
        // });
      } catch (error) {
        console.error("Failed to parse extendData:", error);
      }
    }
  });

  isListenerRegistered = true;
};

const safeGetToken = async (messaging: Messaging, config: any) => {
  if (!isBrowserSupported()) {
    console.warn("Push notifications are not supported in this browser");
    return null;
  }
  if (!messaging || !firebaseConfig.vapidKey) {
    return null;
  }

  try {
    return await getToken(messaging, config);
  } catch (error) {
    console.error("Error getting FCM token:", error);
    return null;
  }
};

export {
  onMessage,
  messaging,
  setupForegroundMessageListener,
  isBrowserSupported,
  safeGetToken as getToken,
};
